import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import layout from '../../HRDashboard/hmsPage.module.css';

export const SafetyRepHero = ({ title, intro }: { title: string; intro?: string }): ReactElement => {
  const { t } = useTranslation();
  return (
    <section className={layout.hero}>
      <div aria-hidden="true" className={layout.backdrop} />
      <div className={layout.heroContent}>
        <span className={layout.eyebrow}>{t('safetyRep.eyebrow')}</span>
        <Heading level={1} data-size="xl">
          {title}
        </Heading>
        {intro && <Paragraph className={layout.intro}>{intro}</Paragraph>}
      </div>
    </section>
  );
};
